import type { Release } from '../releases';

export default {
  id: '2026-11-04-kb-related-in-cards',
  at: '2026-11-04T10:23:00Z',
  title: '«Статьи по теме» прямо в карточках проекта, договора, замечания и работы графика',
  modules: ['kb', 'overview', 'contracts', 'supervision', 'schedule'],
  items: [
    'В карточке проекта (вкладка «Обзор»), договора, замечания надзора и в окне работы графика появилась панель «Статьи по теме» — статьи базы знаний, связанные с этой записью. В договоре — статьи к его виду (поставка, подряд, аренда техники и другие), в работе графика — к самой работе и к её виду работ.',
    'Панель видна, только если такие статьи есть и читателю разрешено их видеть; черновики и статьи, закрытые по ролям, не показываются.',
  ],
  why: 'Статьи к записи были видны только в панели «Помощь»; теперь регламент или урок проекта виден сразу там, где по нему работают.',
  link: '/kb',
} satisfies Release;
